import { TOOGLE_NAV } from '../constants/navbarConstant';

export const toogleNavbar = () => (dispatch) => {
  dispatch({
    type: TOOGLE_NAV,
  });
};
